import { Currency } from '../constants/currencies';

const map: Record<Currency, string> = {
  '₴': 'UAH',
  '€': 'EUR',
};

const currency = (sum: string | number | undefined, symbol?: Currency, showAsSymbol?: boolean, toFixed: number = 2) => {
  const value = Number(sum) ? Number(sum) / 100 : 0;

  if (!symbol) {
    return value.toFixed(toFixed);
  }

  if (symbol && showAsSymbol) {
    return `${value.toFixed(toFixed)}${symbol}`;
  }

  return value.toLocaleString(symbol === '₴' ? 'uk-UA' : 'es-ES', { style: 'currency', currency: map[symbol || '€'] });
};

export default currency;
